import { useEffect, useState } from 'react';
import { useCurrencyWithSymbol } from 'src/common/hooks/widgets/useCurrencyWithSymbol';
import { RATES } from '../constants/price';

/**
 * Calculate the estimated price
 *
 * @param {string} langCode: to define the language
 * @param {string} localCurrency the language code to get the currency sign for
 * @returns {Array}
 */

export interface PropsFunc {
  currency: string;
  localeCode: string;
  country: string;
  usage: number;
  retrieval: number;
  classA: number;
  classB: number;
}

export const usePrice = ({
  currency,
  localeCode,
  usage,
  retrieval,
  classA,
  classB,
}: PropsFunc) => {
  const [totalMthlyCost, setTotalMthlyCost] = useCurrencyWithSymbol(
    currency,
    localeCode,
    0,
  );
  const [totalCost, setTotalCost] = useState(0);

  useEffect(() => {
    const usageCost = Math.round(usage * RATES.storage_per_gb);
    const retrievalCost = Math.round(retrieval * RATES.retrieval_per_gb);
    const classACost = Math.round((classA * RATES.classA_per_gb) / 1000);
    const classBCost = Math.round((classB * RATES.classB_per_gb) / 10000);

    const totalPrice = usageCost + retrievalCost + classACost + classBCost;
    setTotalMthlyCost(totalPrice);
    setTotalCost(totalPrice);
  }, [retrieval, usage, classA, classB]);

  return [totalCost, totalMthlyCost];
};
